module.exports = __webpack_public_path__ + "static/BannerSide-1124e0626ce2d0197d612d57f0b843ef.png";